import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import TeamService from "../services/team.service";

import { rejectedList } from "./listState";
const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0,
};

export const getTeams = createAsyncThunk(
  "Team/get_list",
  async ({ search }, thunkAPI) => {
    try {
      const data = await TeamService.getTeams(search);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getTeamUi = createAsyncThunk(
  "Team/get_ui",
  async (_, thunkAPI) => {
    try {
      const data = await TeamService.getTeamUi();
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createTeam = createAsyncThunk(
  "Team/create",
  async ({ team }, thunkAPI) => {
    try {
      const response = await TeamService.createTeam(team);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateTeam = createAsyncThunk(
  "Team/update",
  async ({ team }, thunkAPI) => {
    try {
      const response = await TeamService.updateTeam(team);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteTeam = createAsyncThunk(
  "Team/delete",
  async ({ id }, thunkAPI) => {
    try {
      await TeamService.deleteTeam(id);
      thunkAPI.dispatch(setMessage({ message: "Team deleted successfully", type: "success" }));
      return { id };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  data: list,
  ui: {
    columns: [],
    columnsVisability: {},
    sort: "",
  },
  loading: false,
};

const TeamSlice = createSlice({
  name: "Team",
  initialState,

  extraReducers: {
    [getTeams.pending]: (state) => {
      state.loading = true;
    },
    [getTeams.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.loading = false;
    },
    [getTeams.rejected]: (state, action) => {
      state.data = rejectedList(state.data, action);
      state.loading = false;
    },

    [getTeamUi.pending]: (state) => {
      state.loading = true;
    },
    [getTeamUi.fulfilled]: (state, action) => {
      state.ui = action.payload.data;
      state.loading = false;
    },
    [getTeamUi.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const { reducer } = TeamSlice;
export default reducer;
